import type {GridMediaItemStorage} from '@Components/base-grid/components/grid-media-item';
import {GridMediaItem} from '@Components/base-grid/components/grid-media-item';
import type {GridItemProps, GridStockMediaItemBackendData} from '@Components/base-grid/components/grid-item';
import type {ReactElement} from 'react';
import React, {useState} from 'react';
import styles from '@Components/base-grid/components/grid-sticker-item/grid-sticker-item.module.scss';

export interface GridStillStickerItemStorage extends GridMediaItemStorage {
  hashedFilename: string;
}

export interface GridStillStickerItemBackEndData extends GridStockMediaItemBackendData {
  idPMWStockStillSticker: string;
}

interface GridStillStickerItemProps extends GridItemProps {
  thumbSrc: string;
}

export function GridStillStickerItem({...props}: GridStillStickerItemProps): ReactElement<any> {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  return (
    <GridMediaItem
      {...props}
      isImageLoaded={isImageLoaded}
      thumb={
        <img
          onLoad={(): void => {
            return setIsImageLoaded(true);
          }}
          src={props.thumbSrc}
          className={`radius-12 ${styles.thumb}`}
          alt={window.i18next.t('pmwjs_image')}
          draggable="false"
          loading="lazy"
        />
      }
    />
  );
}
